export default __webpack_public_path__ + "static/media/emailWhiteSVG.1ee944b0.png";